import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CandidateService } from '$synapse/services';
import { CandidateDTO } from '$synapse/dtos';

@Injectable({
  providedIn: 'root',
})
export class CandidateDetailsResolver {
  private readonly _candidateService = inject(CandidateService);

  resolve(route: ActivatedRouteSnapshot): Observable<CandidateDTO> {
    return this._candidateService.findOne(route.params['id']);
  }
}
